export const getBackgrounds = state => state.backgrounds.publicBackgrounds.items;
